import type { Program } from '../../types';
import { mkt101Course } from './mkt101';
import { sal101Course } from './sal101';
import { bus101Course } from './bus101';
import { mkt102Course } from './mkt102';
import { sal102Course } from './sal102';
import { mkt103Course } from './mkt103';
import { mkt201Course } from './mkt201';
import { sal201Course } from './sal201';
import { mkt202Course } from './mkt202';
import { sal202Course } from './sal202';
import { mkt203Course } from './mkt203';
import { bus201Course } from './bus201';
import { mkt204Course } from './mkt204';
import { mkt301Course } from './mkt301';
import { sal301Course } from './sal301';
import { mkt302Course } from './mkt302';
import { mkt303Course } from './mkt303';
import { mktSal401Course } from './mktSal401';
import { mkt402Course } from './mkt402';
import { cap400Course } from './cap400';
import { salesMarketingStubCourses } from './programCourseStubs';
import programCoverImage from '../../assets/course/sales-marketing-program/program-cover-growth-engine.svg';

const PROGRAM_ID = 'pulkra-sales-marketing-program';

const builtCourses = [mkt101Course, sal101Course, bus101Course, mkt102Course, sal102Course, mkt103Course, mkt201Course, sal201Course, mkt202Course, sal202Course, mkt203Course, bus201Course, mkt204Course, mkt301Course, sal301Course, mkt302Course, mkt303Course, mktSal401Course, mkt402Course, cap400Course];
builtCourses.forEach(c => { c.programId = PROGRAM_ID; });
const builtIds = new Set(builtCourses.map(c => c.id));
const remainingStubs = salesMarketingStubCourses.filter(c => !builtIds.has(c.id));
remainingStubs.forEach(c => { c.programId = PROGRAM_ID; });

export const salesMarketingProgram: Program = {
  id: PROGRAM_ID,
  title: 'Pulkra Sales & Marketing Program',
  shortTitle: 'Sales & Marketing Program',
  category: 'Sales & Marketing',
  description: 'A three-year, twenty-course Sales & Marketing program (plus capstone) built entirely on one real business: foundational marketing, selling, and communication in Year 1; positioning, consultative selling, brand, digital acquisition, negotiation, and retention in Year 2; analytics, sales management, competitive strategy, unit economics, integrated go-to-market strategy, and AI governance in Year 3 — culminating in a defended capstone Business Growth Blueprint.',
  duration: '3 years · 20 courses',
  featured: true,
  accent: '#4f7fd1',
  image: programCoverImage,
  courses: [mkt101Course, sal101Course, bus101Course, mkt102Course, sal102Course, mkt103Course, mkt201Course, sal201Course, mkt202Course, sal202Course, mkt203Course, bus201Course, mkt204Course, mkt301Course, sal301Course, mkt302Course, mkt303Course, mktSal401Course, mkt402Course, cap400Course, ...remainingStubs]
};
